import React from "react"
/* custom component */
import Header from "../../../component/Header/Header"
import { PageContainer, LayoutContainer } from "../../../component/Xcomponent"
import BulkUpload from "../../../component/BulkUpload/BulkUpload"

/* actions */

/* otehrs */

export const DoctorMasterBulkUpload = props => {
    /* variables */
    return (
        <>
            <Header
                backButton={"/doctor-master/list"}
                title={"Doctor Master Bulk Upload"}
            />
            <PageContainer>
                <LayoutContainer>
                    <BulkUpload master="doctorMaster" backUrl="/doctor-master/list" apiUrl="doctor/bulk-upload" />
                </LayoutContainer>
            </PageContainer>
        </>
    )
}

export default DoctorMasterBulkUpload;